import { ActivityPartAxis } from '@/api/models/aggregate'

export const getParentAxis = (axis: ActivityPartAxis | null) =>
  axis?.split('/').slice(0, -1).join('/') as ActivityPartAxis

export const hasAxis = (axis: ActivityPartAxis | null) =>
  axis !== ('' as ActivityPartAxis) && (axis?.split?.('/')?.length ?? 0) > 0
